/* eslint-disable */
import axios, { AxiosRequestConfig } from 'axios';
import qs from 'qs';
import * as commonSDK from 'hybrid-sdk-common';
import { isiOS, isAndroid, isHarmony } from '@k/system';
import { api } from './api';
import { isInHomeWork } from '@/utils/tools';
const isMock = process.env.NODE_ENV === 'development' && !process.env.VUE_APP_PROXY_ENV;
const hybrid = commonSDK.hybrid;
interface RequestOptions {
  headers?: { [key: string]: unknown };
  method: string;
  url: string;
  params?: { [key: string]: unknown };
  data?: string | FormData;
}

interface ResponseOptions {
  errNo: string | number;
  errstr: string;
  data: { [key: string]: unknown };
}

/**
 * axios 默认配置
 */
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  error => {
    return Promise.reject(error.response);
  }
);

/**
 * 响应处理
 */
function responseHandler(response: ResponseOptions) {
  const { errNo } = response;
  if (typeof errNo !== 'undefined') {
    switch (Number(errNo)) {
      case 0:
        return response;
      case 3:
      case 13:
        console.log('未登录'); //  eslint-disable-line
        return Promise.reject(response); //  eslint-disable-line
      default:
        return Promise.reject(response); //  eslint-disable-line
    }
  }
}

/**
 * 获取action名称 (灬°ω°灬)
 */
function getActionName() {
  let actionName = '';
  isiOS && (actionName = 'decode_httpRequest');
  isAndroid && (actionName = 'core_httpRequest');
  isHarmony && (actionName = 'core_httpRequest');
  if (isInHomeWork && isiOS) actionName = 'core_httpRequest';
  return actionName;
}

/**
 *  NA 请求封装
 */
async function naRequest(
  type: string,
  url: string,
  params: { [index: string]: string | Blob },
  options?: { [index: string]: string | number | boolean | { [key: string]: unknown } }
) {
  !params && (params = {});
  try {
    let result: any = null; // eslint-disable-line
    const actionName = getActionName();
    console.log('🚀 ~ actionName:', actionName);
    // if (!inApp || actionName === '') {
    //   throw new Error('[dx-app]获取action名称失败');
    // }
    await new Promise(resolve => hybrid(actionName, { url, params, type, ...options }, resolve)) // eslint-disable-line
      .then((res: any) => {
        // eslint-disable-line
        try {
          if (actionName === 'decode_httpRequest') {
            result = responseHandler(res);
          } else {
            console.log(res, res);
            const { data } = res;
            const response = data;
            result = responseHandler(response);
            // const { data, code } = res;
            // if (Number(code) === 200) {
            //   const response = data.data;
            //   result = responseHandler(response);
            // } else {
            //   result = Promise.reject(new Error('请求失败'));
            // }
          }
        } catch (e) {
          console.log('未知错误', e); //  eslint-disable-line
          result = Promise.reject(new Error('请求失败'));
        }
      });
    return result;
  } catch (error) {
    console.log('未知错误'); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}

/**
 *  FE Ajax 请求封装
 */
async function feRequest(
  type: string,
  url: string,
  params: { [index: string]: string | Blob },
  options?: { [index: string]: string | number | boolean | { [key: string]: unknown } }
) {
  const base: RequestOptions = { method: type, url };
  type === 'get' && (base.params = params);
  type === 'post' && (base.data = qs.stringify(params));
  if (type === 'form') {
    const formData = new FormData();
    Object.keys(params).forEach(el => {
      formData.append(el, params[el]);
    });
    base.method = 'post';
    base.data = formData;
    base.headers = { 'content-type': 'multipart/form-data' };
  }
  try {
    const response = await axios(Object.assign(base, options) as AxiosRequestConfig);

    return responseHandler(response.data);
  } catch (error) {
    console.log('未知错误', error); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}
/**
 * http 封装（目前仅支持get/post/form）
 */
function http(
  type: string
): (
  url: string,
  params: { [index: string]: string | Blob },
  options?: { [index: string]: string | number | boolean | { [key: string]: unknown } }
) => void {
  return async function (
    url: string,
    params: { [index: string]: string | Blob },
    options?: { [index: string]: string | number | boolean | { [key: string]: unknown } }
  ) {
    const method = type === 'naCore' ? 'post' : type;
    console.log('url', url);
    if (type === 'naCore' && !isMock) {
      // 带 antispam 参数返回值不加密
      return naRequest(method, url, params, { paramsEncode: 1, shouldDecode: 0 });
    } else {
      // FE 接口请求
      return feRequest(method, url, params, options);
    }
  };
}

/**
 *  端内加密 请求封装
 */
async function deRequest(url: string, params: { [index: string]: string | Blob }): Promise<void> {
  !params && (params = {});
  try {
    let result: any = null; // eslint-disable-line
    await new Promise(resolve => hybrid('decode_httpRequest', { url, params, shouldDecode: 1 }, resolve)) //  eslint-disable-line
      .then((res: any) => {
        // eslint-disable-line
        try {
          if (res) {
            console.log(' ~ deRequest ~ res:', res);
            if (res.data === '') res.data = {};
            res.data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
            result = responseHandler(res);
          } else {
            result = Promise.reject(new Error('请求失败'));
          }
        } catch (e) {
          console.log('未知错误', e); //  eslint-disable-line
          result = Promise.reject(new Error('请求失败'));
        }
      });
    return result;
  } catch (error) {
    console.log('未知错误'); //  eslint-disable-line
    return Promise.reject(new Error('请求失败'));
  }
}

export const $ajax = axios;

export const $get = http('get');

export const $post = http('post');

export const $form = http('form');

export const $naCore = http('naCore');

export const $hybrid = hybrid;

export const $deHttp = deRequest;

export default {
  install(Vue: Vue.VueConstructor): void {
    Vue.$ajax = Vue.prototype.$ajax = $ajax;
    Vue.api = Vue.prototype.api = api;
    Vue.$http = Vue.prototype.$http = {
      get: $get,
      post: $post,
      form: $form,
      naCore: $naCore,
      entry: $deHttp
    };
  }
};
